import React from 'react'

import { Box } from '@domain-group/suit-theme'

import Footer from './Footer'
import Paragraph from './Paragraph'
import Title from './Title'

interface NoticeBoxProps {
  actionContent?: React.ReactNode,
  boxProps?: object,
  children: React.ReactNode,
  footer?: React.ReactNode,
  icon?: React.ReactNode,
  iconInlineWithTitle?: boolean,
  variant?: string,
}

const NoticeBox = (props: NoticeBoxProps) => {
  const {
    actionContent, boxProps, children, footer, icon, iconInlineWithTitle, variant = 'white',
  } = props

  return (
    <Box
      alignItems="center"
      flexDirection="column"
      flexShrink={0}
      lineHeight="1.3"
      marginBottom="large"
      // @ts-expect-error TS2322
      variant={variant}
      {...boxProps}
    >
      <Box alignItems="center" flexDirection={['column', 'row']} padding="large">
        <Box alignItems={iconInlineWithTitle ? '' : 'center'} marginBottom={actionContent ? ['large', 0] : 0}>
          {icon && (
            <Box fontSize="xlarge" marginRight="large" width="auto">
              {icon}
            </Box>
          )}

          <Box alignItems="flex-start" flexDirection="column">
            {children}
          </Box>
        </Box>

        {actionContent}
      </Box>

      {footer}
    </Box>
  )
}

NoticeBox.Footer = Footer
NoticeBox.Paragraph = Paragraph
NoticeBox.Title = Title

export default NoticeBox
